import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-spinner',
    templateUrl: './user-spinner.component.html',
    styleUrls: ['./user-spinner.component.scss'],
    standalone: false
})
export class UserSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
